import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { ProductService } from 'src/app/_service/product.service';

declare var $: any;

@Component({
  selector: 'app-product-model',
  templateUrl: './product-model.component.html',
  styleUrls: ['./product-model.component.css']
})
export class ProductModelComponent implements OnInit {

  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false; fileDeleting: boolean = false;
  fileDeletingLoader: boolean = false;

  dialogData: any; productForm: FormGroup; loading: boolean = false; submitted: boolean = false; dataLoaded: boolean = false;
  bds = []; bds_copy = []; myrole: string = ''; s3url = ''; disableSelect: any = []; invalidName: boolean = false;
  ProductChk:boolean=false;doc_type:string='';uploading:boolean=false;allUploads=[];hospitals=[];hospitals_copy=[];
  all_product_list=[];all_product_list_copy=[];

  constructor(public dialogRef: MatDialogRef<ProductModelComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, private dialog: MatDialog, private router: Router, private sharedapi: SharedService, private leadapi: LeadsService, private formBuilder: FormBuilder, private productapi: ProductService) {
    this.dialogData = data;
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    this.productForm = this.formBuilder.group({
      'patient_name': [null, Validators.required],
      'mobile': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'patient_age': [null, Validators.required],
      'gender': [null, Validators.required],
      'user_id': [null, Validators.required],
      'booking_date': [null, Validators.required],
      'pin_code': [null],
      'address': [null],
      'alt_number': [null],
      // 'product_id': [null, Validators.required],
      // 'quantity': [null, Validators.required],
      'invoice_amount': [null, Validators.required],
      'status': [1, Validators.required],
      'description': [null],
      // 'partial_amount' : [null, Validators.required],
      // 'payment_mode' : [null, Validators.required],
      'receivedAmtResources': this.formBuilder.array([]),
      'productDetails': this.formBuilder.array([]),
      'hospital_id': [null],
    });
  }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
    this.getbds();
    this.getProductLeadDetail();
    this.getProductBookingDetail();
    this.getHospital();
    this.getAllProductsList();
    this.addMoreProductDetail();
  }

  get f() { return this.productForm.controls; }

  setSearchValue(type) {
    if (type == 'lead_owner') {
      $("#ownerSearch").val('');
      $("#ownerSearch").focus();
      this.bds = this.bds_copy;
    } else if(type=='hospital'){
      $("#hospitalSearch").val('');
      $("#hospitalSearch").focus();
      this.hospitals= this.hospitals_copy;
    } else if(type=='product'){
      $("#productSearch").val('');
      $("#productSearch").focus();
      this.all_product_list= this.all_product_list_copy;
    }
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_owner') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    } else if(type == 'hospital'){
      this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
    } else if(type == 'product'){
      this.all_product_list = this.sharedapi.searchData(searchtText, this.all_product_list_copy, "name");
    }
  }

  async getProductLeadDetail() {
    this.dataLoaded = false;
    await this.leadapi.getProductLeadDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        this.productForm.controls['patient_name'].setValue(data.data.lead_name);
        this.productForm.controls['mobile'].setValue(data.data.mobile);
        this.productForm.controls['user_id'].setValue(data.data.user_id);
        this.productForm.controls['patient_age'].setValue(data.data.patient_age);
        this.productForm.controls['gender'].setValue(data.data.gender);
      } else {
        this.sharedapi.checkError(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getProductBookingDetail() {
    this.dataLoaded = false;
    await this.productapi.getProductBookingDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if (data.status) {
        if (data.productBook) {
          this.productForm.controls['address'].setValue(data.productBook.address);
          this.productForm.controls['alt_number'].setValue(data.productBook.alternate_number);
          this.productForm.controls['pin_code'].setValue(data.productBook.area_pincode);
          this.productForm.controls['booking_date'].setValue(data.productBook.booking_date);
          this.productForm.controls['invoice_amount'].setValue(data.productBook.invoice_amount);
          // this.productForm.controls['product_id'].setValue(data.productBook.product_id);
          // this.productForm.controls['quantity'].setValue(data.productBook.quantity);
          this.productForm.controls['description'].setValue(data.productBook.description);
          this.productForm.controls['status'].setValue(data.productBook.status);
          this.productForm.controls['hospital_id'].setValue(data.productBook.hospital_id);
        }
        if (data.productPayment) {
          let controlArray = this.productForm.get('receivedAmtResources') as FormArray;
          controlArray.clear();
          data.productPayment.forEach((element, index) => {
            controlArray.push(this.formBuilder.group({
              payment_mode: element.payment_mode,
              partial_amount: element.received_amount,
              productPaymentId: element.id
            }));
          });
        }
        if(data.productBook.invoice_amount != null && data.productBook.invoice_amount != "null" && data.productBook.invoice_amount != "") {
          this.ProductChk = true;
        }
        if(data.uploads) {
          this.allUploads = data.uploads;
        }
        if (data.productDetails) {
          let productControlArray = this.productForm.get('productDetails') as FormArray;
          productControlArray.clear();
          data.productDetails.forEach((element, index) => {
            productControlArray.push(this.formBuilder.group({
              productDetailId: element.id,
              product_id: element.product_id,
              product_quantity: element.quantity
            }));
          });
        }
       
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async productSubmit() {
    this.submitted = true;
    this.loading = true;
    if (this.productForm.invalid) {
      this.loading = false;
      return;
    }
    // validation for product detail array
    let productDetailsArrayLength = this.productForm.value.productDetails.length;
    if(productDetailsArrayLength < 1) {
      this.sharedapi.presentToast("Please select any product first");
      this.loading = false;
      return;
    }
    // end
    await this.productapi.updateProductDetail(this.dialogData.lead_id, this.productForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.getProductBookingDetail();
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  async getbds() {
    this.leadapi.getbds().subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  receivedAmtResources(): FormArray {
    return this.productForm.get("receivedAmtResources") as FormArray
  }

  addMoreReceivedAmount() {
    this.receivedAmtResources().push(this.newQuantity());
    let getIndex = this.productForm.controls["receivedAmtResources"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      productPaymentId: '',
      payment_mode: [null, Validators.required],
      partial_amount: [null, Validators.required],
    })
  }

  removeQuantity(i: number, productPaymentId) {
    if (productPaymentId) {
      this.productapi.amountReceivedDeleted(productPaymentId).subscribe((data: any) => {
        if (data.status) {
          this.getProductBookingDetail();
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
    else {
      this.receivedAmtResources().removeAt(i);
    }
  }

  async selectFile(event)
  {
      if(this.doc_type!="")
      {
          this.uploading = true;
          let file = event.target.files.item(0);
          const formData = new FormData();
          formData.append('upload_type',this.doc_type)
          formData.append('file', file);
          await this.productapi.uploadProductFile(this.dialogData.lead_id,formData)
          .subscribe((data:any) => {
              this.uploading = false;
              if(data.status) {
                  this.sharedapi.presentToast('File uploaded Successful');
                  this.getProductBookingDetail();
              } else {
                  this.sharedapi.presentToast(data.msg);
              }
            }, error =>
              {
                  this.uploading = false;
                  this.sharedapi.checkError(error);
              });
      }else{
          this.sharedapi.presentToast('Please select Document Type');
      }
  }

  removeFile(fileId)
  {
      this.fileDeleting = true;
      this.productapi.deleteProductFile(fileId).subscribe((data:any) => {
          this.fileDeleting = false;
          if(data.status)
          {
              this.getProductBookingDetail();
          }else{
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  addMoreProductDetail() {
    this.receivedProductResources().push(this.newProduct());
    let getIndex = this.productForm.controls["productDetails"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  receivedProductResources(): FormArray {
    return this.productForm.get("productDetails") as FormArray
  }

  newProduct(): FormGroup {
    return this.formBuilder.group({
      productDetailId: '',
      product_id: [null, Validators.required],
      product_quantity: [null, Validators.required],
    })
  }

  removeProductQuantity(i: number, productDetailId) {
    if (productDetailId) {
      this.productapi.productDetailDeleted(productDetailId).subscribe((data: any)=> {
        if (data.status) {
          this.getProductBookingDetail();
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
    else {
      this.receivedProductResources().removeAt(i);
    }
  }

  async getHospital()
    {
        await this.leadapi.getProductClinics().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getAllProductsList()
    {
        await this.productapi.getAllProductsList().subscribe((data:any) => {
            if(data.status)
            {
                this.all_product_list = data.data;
                this.all_product_list_copy= this.all_product_list;
            }else{
                this.all_product_list = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
